module.exports = __webpack_public_path__ + "media/src/images/icon/book-3651ca1f874f486a2f9fd94f35180eca.png";